import { IDs } from '../../../helpers/IDs';
import { getVerbrauchStufe } from '../../zusatztools/ZusatzToolsModulEED';

export function getCustomFormConfigEED(entity: string, item: any, data: any, contextKey?: string, filter?: any): any {
    let config: any = {};
    data = data || {};
    filter = filter || {};
    item = item || {};

    switch (entity) {
        case IDs.ENT_EED_UMFRAGE:
            const kennzahlen = data[IDs.KENNZIFFERN_BERECHNET];
            const verbrauchStufe = getVerbrauchStufe(kennzahlen);
            config = {
                ...config,
                verbrauch: { readonly: true }
            }

            // EEV ≥ 85 TJ
            if (verbrauchStufe === 2) {
                if (isJa('hat_ems_zertifikat', item)) {
                    config = {
                        ...config,
                        datum_ems_zertifikat_von: { hidden: false },
                        datum_ems_zertifikat_bis: { hidden: false },
                    }
                } else {
                    config = {
                        ...config,
                        hat_ems_einfuehrung: { hidden: false }
                    }
                    if (isJa('hat_ems_einfuehrung', item)) {
                        config = {
                            ...config,
                            // ???
                        }
                    } else {
                        config = {
                            ...config,
                            hat_eek: { hidden: false },
                        }
                        if (isJa('hat_eek', item)) {
                            config = {
                                ...config,
                                eek_anbieter: { hidden: false },
                                datum_eek_von: { hidden: false },
                                datum_eek_bis: { hidden: false }
                            }
                        } else {
                            config = {
                                ...config,
                                hat_eek_einfuehrung: { hidden: false }
                            }
                            if (isJa('hat_eek_einfuehrung', item)) {
                                config = {
                                    ...config,
                                    // ???
                                }
                            } else {
                                config = {
                                    ...config,
                                    hat_ums: { hidden: false }
                                }
                                if (isJa('hat_ums', item)) {
                                    config = {
                                        ...config,
                                        datum_ums_von: { hidden: false },
                                        datum_ums_bis: { hidden: false }
                                    }
                                } else {
                                    config = {
                                        ...config,
                                        hat_ums_einfuehrung: { hidden: false }
                                    }
                                }
                            }
                        }
                    }
                }
            } else
                // 10 TJ ≤ EEV < 85 TJ
                if (verbrauchStufe === 1) {
                    if (isJa('hat_ems_zertifikat', item)) {
                        config = {
                            ...config,
                            datum_ems_zertifikat_von: { hidden: false },
                            datum_ems_zertifikat_bis: { hidden: false },
                        }
                    } else {
                        config = {
                            ...config,
                            hat_ems_einfuehrung: { hidden: false }
                        }
                        if (isJa('hat_ems_einfuehrung', item)) {
                            config = {
                                ...config,
                                // ???
                            }
                        } else {
                            config = {
                                ...config,
                                hat_audit: { hidden: false },
                            }
                            if (isJa('hat_audit', item)) {
                                config = {
                                    ...config,
                                    datum_audit: { hidden: false }
                                }
                            } else {
                                config = {
                                    ...config,
                                    hat_audit_durchfuehrung: { hidden: false }
                                }
                                if (isJa('hat_audit_durchfuehrung', item)) {
                                    config = {
                                        ...config,
                                        // ???
                                    }
                                } else {
                                    config = {
                                        ...config,
                                        hat_eek: { hidden: false },
                                    }
                                    if (isJa('hat_eek', item)) {
                                        config = {
                                            ...config,
                                            eek_anbieter: { hidden: false },
                                            datum_eek_von: { hidden: false },
                                            datum_eek_bis: { hidden: false }
                                        }
                                    } else {
                                        config = {
                                            ...config,
                                            hat_eek_einfuehrung: { hidden: false }
                                        }
                                        if (isJa('hat_eek_einfuehrung', item)) {
                                            config = {
                                                ...config,
                                                // ???
                                            }
                                        } else {
                                            config = {
                                                ...config,
                                                hat_ums: { hidden: false }
                                            }
                                            if (isJa('hat_ums', item)) {
                                                config = {
                                                    ...config,
                                                    datum_ums_von: { hidden: false },
                                                    datum_ums_bis: { hidden: false }
                                                }
                                            } else {
                                                config = {
                                                    ...config,
                                                    hat_ums_einfuehrung: { hidden: false }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
    }

    return config;
}

function isJa(key: string, data: any): boolean {
    return (+data[`${key}_orig`] || +data[key]) === 1 || data[key] === 'Ja';
}

function isNein(key: string, data: any): boolean {
    return (+data[`${key}_orig`] || +data[key]) === 2 || data[key] === 'Nein';
}
